import {
  GridCellSummary,
  GridWithMinimalCells,
  InaccessibleStorable,
  MinimalContainer,
} from 'constants/SampleConstants';
import * as SampleUtil from 'samples/SampleUtil';

export interface ScanToMoveGridCell extends GridCellSummary {
  container?: MinimalContainer | InaccessibleStorable | null;
  /** Whether the container is already persisted in the grid. */
  isPreexisting: boolean;
  /** Original grid coordinates of the container in the grid if pre-existing and has been moved */
  originalGridCoordinates?: string | null;
}

export interface ScanToMoveCellByCoordinates {
  [gridCoordinates: string]: ScanToMoveGridCell;
}

/**
 * Combine existing grid with containers pending to be moved in into one grid view.
 */
export function buildDraftGridWithScannedContainers(
  grid: GridWithMinimalCells,
  containers: ScanToMoveCellByCoordinates | null
): GridWithMinimalCells {
  if (!containers || !Object.keys(containers).length) {
    return grid;
  }
  const {cells, ...baseGrid} = grid;
  const width = cells[0].length;
  const height = cells.length;
  const cellsWithScannedContainers = [...Array(height)].map((_, rowIndex: number) =>
    [...Array(width)].map((_, columnIndex: number) => {
      const coordinates = SampleUtil.formatGridCoordinates(rowIndex, columnIndex);
      const cell = containers[coordinates];
      // Spread so that TS understands the type of the container
      return cell != null && cell.container != null ? {...cell, container: cell.container} : null;
    })
  );
  return {...baseGrid, cells: cellsWithScannedContainers};
}
